import cx from 'classnames';
import {NavBottom} from '~/OneStepCreateInvitation/components/NavBottom/NavBottom';

export const NavBottomWrapper = ({
  innerRef,
  showBottomNav,
  currentSection,
  isUsingPremiumFeature,
  bottomCtas,
  isPremium,
  usedPremiumFeature,
  children,
}) => (
  <NavBottom
    innerRef={innerRef}
    className={cx('animate__animated', {
      'next-button-showing': showBottomNav,
      'tooltip-position': currentSection === 'card_design',
      'step4-premium-upsell-ctas': usedPremiumFeature && !isPremium,
    })}
    hideContinueButton={!isUsingPremiumFeature}
    firstChild={children}
    ctas={bottomCtas}
  />
);
